import React from 'react';
import { VS } from 'libs/growth-platform-brand-system-v2/src/templates/VS';
import { Icon } from 'libs/growth-platform-brand-system-v2/src/components/Picto/Icon';

const preparePositifItems = (items: any) => {
  return items.map((item: any) => {
    return `<svg class="w-40 h-40" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" fill="#0F6FDE"/><path d="M19 21.5C19 21.2239 18.7761 21 18.5 21H14C13.4477 21 13 20.5523 13 20C13 19.4477 13.4477 19 14 19H18.5C18.7761 19 19 18.7761 19 18.5V14C19 13.4477 19.4477 13 20 13C20.5523 13 21 13.4477 21 14V18.5C21 18.7761 21.2239 19 21.5 19H26C26.5523 19 27 19.4477 27 20C27 20.5523 26.5523 21 26 21H21.5C21.2239 21 21 21.2239 21 21.5V26C21 26.5523 20.5523 27 20 27C19.4477 27 19 26.5523 19 26V21.5Z" fill="white"/></svg>
  <div class="flex-1">${item.content}</div>`;
  });
};
const prepareNegatifItems = (items: any) => {
  return items.map((item: any) => {
    return `<svg class="w-40 h-40" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" fill="#DFE6ED"/><path d="M13.5 21C13.2239 21 13 20.7761 13 20.5V19.5C13 19.2239 13.2239 19 13.5 19H26.5C26.7761 19 27 19.2239 27 19.5V20.5C27 20.7761 26.7761 21 26.5 21H13.5Z" fill="#768699"/></svg>
  <div class="flex-1">${item.content}</div>`;
  });
};

export const VersusComponent = ({ block, locale }: any) => {
  const positiveColumn = block?.positiveColumn && {
    ...block?.positiveColumn,
    picto: block?.positiveColumn?.picto ? (
      <Icon
        {...block?.positiveColumn?.picto}
        width={80}
        height={80}
        className="w-72 md:w-80"
      />
    ) : null,
    items: preparePositifItems(block?.positiveColumn?.items),
  };

  const negativeColumn = block?.negativeColumn && {
    ...block?.negativeColumn,
    picto: block?.negativeColumn?.picto ? (
      <Icon
        {...block?.negativeColumn?.picto}
        width={80}
        height={80}
        className="w-72 md:w-80"
      />
    ) : null,
    items: prepareNegatifItems(block?.negativeColumn?.items),
  };

  return (
    <VS
      title={block.title}
      subtitle={block.versusSubtitle}
      positifColumn={positiveColumn}
      negativeColumn={negativeColumn}
      anchor={block.anchor}
    />
  );
};

export default VersusComponent;
